import { Modal } from 'bootstrap';
import jsKit from './jsKit';

const getForm = (element) => element.closest('#delivery_pricelist_form');

const requestDeliveryPricelist = async (url, form, trigger) => {
  const formData = new URLSearchParams(new FormData(form));

  jsKit.setLoading(form, true);
  jsKit.setLoading(trigger, true, { disabled: true });

  const response = await jsKit.requestUrl(url, 'urlencoded', 'POST', formData);

  jsKit.setLoading(form, false);
  jsKit.setLoading(trigger, false, { disabled: true });

  return response;
};

const changeDeliveryPriceListCountry = async (event) => {
  const trigger = event.delegateTarget || event.currentTarget;
  const form = getForm(trigger);
  if (!form) return;

  const response = await requestDeliveryPricelist('/page/changeDeliveryPriceListCountry/', form, trigger);
  if (response?.status && response.html) {
    jsKit.setHtml('#price-list-index', response.html);
  }
};

const showDeliveryPriceLists = async (event) => {
  event.preventDefault();

  const trigger = event.delegateTarget || event.currentTarget;
  const form = getForm(trigger);
  if (!form) return;

  jsKit.setHtml('#price-list-details', '');
  const response = await requestDeliveryPricelist('/page/showDeliveryPriceLists/', form, trigger);
  if (!response?.status || typeof response.html === 'undefined') return;

  jsKit.setHtml('#price-list-details', response.html);
  const modal = document.getElementById('price-list-modal');
  if (modal) {
    Modal.getOrCreateInstance(modal).show();
  }
};

export const deliveryPricelistEvents = [
  ['jsDeliveryPricelistForm', (event) => event.preventDefault(), 'submit'],
  ['jsChangeDeliveryPriceListCountry', changeDeliveryPriceListCountry, 'change'],
  ['jsShowDeliveryPriceLists', showDeliveryPriceLists],
];
